import { render, staticRenderFns } from "./ImportViewGlobal.vue?vue&type=template&id=591e457e&"
import script from "./ImportViewGlobal.vue?vue&type=script&lang=js&"
export * from "./ImportViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports